import AuthSettingsPage from './AuthSettingsPage';
import ConfigureWithOAuthButton from './ConfigureWithOAuthButton';
import ConfigureWithOAuthPage from './ConfigureWithOAuthPage';

export const components = {
  AuthSettingsPage,
  ConfigureWithOAuthButton,
  ConfigureWithOAuthPage,
};
